"use client";

import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
export default function Splash() {
  const [isVisible, setIsVisible] = useState(true);
  const shouldReduceMotion = useReducedMotion();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isVisible]);
  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setIsVisible(false);
    }, shouldReduceMotion ? 100 : 2600);
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [shouldReduceMotion]);
  return <section id="introsplash" data-nav="light" className="relative">
      <AnimatePresence>
        {isVisible && <motion.div initial={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: shouldReduceMotion ? 0.2 : 0.75,
        ease: [0.25, 1, 0.5, 1]
      }} className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden bg-[#F5F4F2] px-6 select-none">
            {/* Phase 2: Background Hero Image Crossfade */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: shouldReduceMotion ? 0 : 1.8,
          duration: shouldReduceMotion ? 0.1 : 1.2,
          ease: [0.33, 1, 0.68, 1]
        }} className="absolute inset-0 z-0 bg-cover bg-center" style={{
          backgroundImage: `url('https://included-grizzly.10web.cloud/wp-content/uploads/2026/08/IMG_6448-scaled.jpg')`
        }} />

            {/* Phase 1: Static Text */}
            <div className="relative z-10 flex flex-col items-center justify-center text-center">
              <h1 className="font-serif text-2xl font-normal uppercase tracking-[0.38em] text-foreground md:text-4xl lg:text-5xl">
                S &amp; L DESIGN
              </h1>
            </div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}